import { NextSeo } from 'next-seo';

//screens
import { SchedulingAndReScheduling } from '@/screens/Agents/SchedulingAndReScheduling';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function SchedulingAndReSchedulingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/scheduling-and-re-scheduling/"
        title="Scheduling & Re-Scheduling Agent | Loadsmart AI"
        description="Books dock appointments against live carrier and facility availability, then detects a slipped pickup, rebooks it, and notifies everyone who needs to know."
        openGraph={{
          url: 'https://loadsmart.com/ai/scheduling-and-re-scheduling/',
        }}
      />
      <JsonLd data={Organization} />
      <SchedulingAndReScheduling />
    </>
  );
}
